import React from 'react';

import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { KnzComponentProps } from '../../types';

/**
 * リンクカード（WorkflowLinkCard ベース）。
 * params: title（必須）、path（必須, 遷移先）、text（任意, 説明）、color（任意）
 */
export const LinkCard: React.FC<KnzComponentProps> = ({ node }) => {
  const title = (node.params.title as string) ?? '';
  const path = (node.params.path as string) ?? '#';
  const description = node.params.text as string | undefined;
  const color = (node.params.color as string) || 'primary.main';

  return (
    <ButtonBase
      component="a"
      href={path}
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        display: 'block',
        width: 360,
        maxWidth: '100%',
        textAlign: 'left',
        border: 1,
        borderColor: 'divider',
        borderRadius: 2,
        overflow: 'hidden',
        transition: 'border-color 0.2s',
        '&:hover': { borderColor: color },
      }}
    >
      <Box sx={{ height: 4, bgcolor: color }} />
      <Stack spacing={1} sx={{ p: 2 }}>
        <Typography variant="body2" fontWeight={600} sx={{ lineHeight: 1.4 }}>
          {title}
        </Typography>
        {description && (
          <Typography variant="caption" color="text.secondary" sx={{ lineHeight: 1.4 }}>
            {description}
          </Typography>
        )}
        <Stack direction="row" alignItems="center" spacing={0.5} sx={{ alignSelf: 'flex-end' }}>
          <Typography variant="caption" color="text.disabled">
            別タブで開く
          </Typography>
          <OpenInNewIcon sx={{ fontSize: 14, color: 'text.disabled' }} />
        </Stack>
      </Stack>
    </ButtonBase>
  );
};

export default LinkCard;
